import './index.pcss';
import $ from 'jquery';
import 'slick-carousel';


$(document).ready(function () {
    $(".slider-banner-link__slider").slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 2200,
        autoplaySpeed: 2200,
        mobileFirst:true,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        rtl: true
    });

    if (window.matchMedia("(min-width: 1024px)").matches) {
        $('a[data-slide]').click(function (e) {
            $('a[data-slide]').removeClass('active');
            $('.slider-banner-link__links-txt').removeClass('--active');
            $(this).closest('.slider-banner-link__links-txt').addClass('--active');
            $(this).addClass('active');
        });
    }
});
